import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import {
  SUNLOCK_COMMAND_LIST,
} from 'common/sunlocks/sunlockConstants';

import {
  SR_API_ACTION_SUNLOCK_GET_STATUS,
  SR_API_ACTION_SUNLOCK_SEND_COMMAND,
} from 'api/actionTypes';

import log from 'client/lib/log';
import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';
import {
  hideFieldIf,
  createInitialValues,
  createFormValidationFn,
} from 'client/helpers/formikHelpers';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

const SR_SUNLOCK_DEBUG_FORM_ACTION_TYPE_SEND_COMMAND = 'send-command';
const SR_SUNLOCK_DEBUG_FORM_ACTION_TYPE_GET_STATUS = 'get-command';

const makeSunlockRegisterDeviceFormFields = ({ formValues = {}, sunlocksList }) => [
  {
    id: 'selectedSunlockId',
    title: 'Sunlock',
    type: 'select',
    properties: {
      choices: sunlocksList.map((sunlock) => ({
        label: sunlock.raspberryPiSerialNumber,
        value: sunlock.id,
      })),
    },
    validations: ['required'],
  },
  {
    id: 'action',
    title: 'Action',
    type: 'select',
    validations: ['required'],
    properties: {
      choices: [
        {
          label: 'Get status',
          value: SR_SUNLOCK_DEBUG_FORM_ACTION_TYPE_GET_STATUS,
        },
        {
          label: 'Send command',
          value: SR_SUNLOCK_DEBUG_FORM_ACTION_TYPE_SEND_COMMAND,
        },
      ],
    },
  },
  hideFieldIf(formValues.action !== SR_SUNLOCK_DEBUG_FORM_ACTION_TYPE_SEND_COMMAND, {
    id: 'command',
    title: 'Command',
    type: 'select',
    validations: ['required'],
    properties: {
      choices: SUNLOCK_COMMAND_LIST.map((value) => ({
        label: value,
        value: value,
      })),
    },
  }),
];

@branch()
@withApiState({
  sunlockGetStatusApiState: {
    action: SR_API_ACTION_SUNLOCK_GET_STATUS,
  },
  sunlockSendCommandApiState: {
    action: SR_API_ACTION_SUNLOCK_SEND_COMMAND,
  },
})
class SrSunlockDebugForm extends Component {
  static propTypes = {
    sunlocksList: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    sunlockGetStatusApiState: PropTypes.object.isRequired,
    sunlockSendCommandApiState: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      sunlockStatus: null,
      sunlockCommandResponse: null,
    };
  }

  _onSubmit = ({ selectedSunlockId, action, command }) => {
    const { dispatch } = this.props;

    switch (action) {
      case SR_SUNLOCK_DEBUG_FORM_ACTION_TYPE_SEND_COMMAND: {
        dispatch(postWithState, {
          action: SR_API_ACTION_SUNLOCK_SEND_COMMAND,
          payload: {
            sunlockId: parseInt(selectedSunlockId, 10),
            sunlockCommand: command,
          },
        })
          .then((result) => {
            this.setState({
              sunlockStatus: null,
              sunlockCommandResponse: result,
            });
          })
          .catch((error) => {
            log.error(error);
          });
        break;
      }
      case SR_SUNLOCK_DEBUG_FORM_ACTION_TYPE_GET_STATUS: {
        dispatch(postWithState, {
          action: SR_API_ACTION_SUNLOCK_GET_STATUS,
          payload: {
            sunlockId: parseInt(selectedSunlockId, 10),
          },
        })
          .then((sunlockStatus) => {
            this.setState({
              sunlockStatus,
              sunlockCommandResponse: null,
            });
          })
          .catch((error) => {
            log.error(error);
          });
        break;
      }
    }
  }

  render() {
    const {
      sunlocksList,
      sunlockGetStatusApiState,
      sunlockSendCommandApiState,
    } = this.props;

    const {
      sunlockStatus,
      sunlockCommandResponse,
    } = this.state;

    if (
      sunlockGetStatusApiState.isBusy
      || sunlockSendCommandApiState.isBusy
    ) {
      return (
        <div className='loading-gif' />
      );
    }

    return (
      <div>
        <Formik
          enableReinitialize
          onSubmit={this._onSubmit}
          initialValues={createInitialValues({
            formFields: makeSunlockRegisterDeviceFormFields({
              sunlocksList,
            }),
          })}
          validate={(formValues) => {
            const formFields = makeSunlockRegisterDeviceFormFields({
              formValues,
              sunlocksList,
            });
            return createFormValidationFn({
              formFields,
            });
          }}
          render={(formikBag) => {
            const formFields = makeSunlockRegisterDeviceFormFields({
              formValues: formikBag.values,
              sunlocksList,
            });
            return (
              <Form className='p-relative'>
                {formFields.map((formField) => (
                  <SrFormikField
                    key={formField.id}
                    formField={formField}
                    formikBag={formikBag}
                  />
                ))}
                <ButtonDeprecated type='submit' disabled={!formikBag.isValid}>
                  Submit
                </ButtonDeprecated>
              </Form>
            );
          }}
        />
        {sunlockGetStatusApiState.error && (
          <div className='formMessage error'>
            <span>{sunlockGetStatusApiState.error.message}</span>
          </div>
        )}
        {sunlockStatus && (
          <pre>{JSON.stringify(sunlockStatus, null, 2)}</pre>
        )}
        {sunlockSendCommandApiState.error && (
          <div className='formMessage error'>
            <span>{sunlockSendCommandApiState.error.message}</span>
          </div>
        )}
        {sunlockCommandResponse && (
          <pre>{JSON.stringify(sunlockCommandResponse, null, 2)}</pre>
        )}
      </div>
    );
  }
}

SrSunlockDebugForm.displayName = 'SrSunlockDebugForm';

export default SrSunlockDebugForm;
